


export const Field1GroupTitle = {
    "main":             "General",
    "users":            "Users",
    "time":             "Time & Progress",
    "dates":            "Dates",
    "finance":          "Finance",
    "dependencies":     "Dependencies",
    'estimate':         "Estimate",
    'crm':              "CRM",
    "custom-fields":    "Custom fields"
}



// ya ne uveren est' li field3 group - po hodu eto same for both
export enum FieldGroup {
    MAIN = 'main',
    USERS = 'users',
    TIME = 'time',
    DATES = 'dates',
    ESTIMATE = 'estimate',
    FINANCE = 'finance',
    DEPENDENCIES = 'dependencies',
    CRM = 'crm',
    CUSTOM_FIELDS = 'custom-fields',
}


